// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"2":"lang-fr-ts","64":"lang-zh-ts","305":"lang-de-ts","566":"lang-th-ts","597":"lang-no-ts","775":"lang-sv-ts","826":"lang-tt-ts","902":"lang-es-ts"}[chunkId] + "." + {"2":"dbbe1723","64":"1b4f9444","305":"1b72e711","566":"ce916118","597":"3b0b4c04","775":"eca1a694","826":"a51a2842","902":"d800266d"}[chunkId] + ".js";
};